module.exports = __webpack_public_path__ + "static/media/radio-1.814ee3f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/radio-1.svg
// module id = 788
// module chunks = 0